module.exports = __webpack_public_path__ + "fonts/87rdstq3.woff";